import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

const icon = (name) => (
  // <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  <Iconify icon={name} />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  customers: icon('icon-park-outline:customer'),
  staff: icon('ri:admin-fill'),
  credit: icon('entypo:credit'),
  products: icon('ant-design:product-filled'),
  price: icon('material-symbols:paid'),
  categories: icon('material-symbols:category'),
  expires: icon('pajamas:expire'),
  damages: icon('icon-park-solid:damage-map'),
  orders: icon('lets-icons:order'),
  reviews: icon('material-symbols:reviews'),
  delivery: icon('iconamoon:delivery-fill'),
  delivery_person: icon('healthicons:truck-driver'),
  delivery_utility: icon('mdi:spanner'),
  returns: icon('icon-park-outline:return'),
  location: icon('mdi:location'),
  security: icon('material-symbols:security'),
  insight: icon('ic:baseline-insights'),
  banner_config: icon('game-icons:vertical-banner'),
  category_config: icon('carbon:category')
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // CUSTOMER
      // ----------------------------------------------------------------------
      {
        subheader: 'User Management',
        items: [
          { 
            title: 'Customer Management', 
            path: paths.dashboard.user.customer, 
            icon: ICONS.customers,
            children: [
              { title: 'All Customers', path: paths.dashboard.user.customer },
              { title: 'Support', path: paths.dashboard.user.support }
            ]
          },
          { 
            title: 'Staff Management', 
            path: paths.dashboard.user.staff, 
            icon: ICONS.staff,
            children: [
              { title: 'All Staffs', path: paths.dashboard.user.staff }
            ]
          },
          { 
            title: 'Credit Management', 
            path: paths.dashboard.user.credit_approval, 
            icon: ICONS.credit,
            children: [
              { title: 'Credit Approvals', path: paths.dashboard.user.credit_approval },
              { title: 'Credit', path: paths.dashboard.user.credit }
            ]
          },
        ]
      },

      // ITEMS
      // ----------------------------------------------------------------------
      {
        subheader: 'Inventory Management',
        items: [
          { title: 'Product Insights', path: paths.dashboard.item.root, icon: ICONS.insight },
          { 
            title: 'Product Management', 
            path: paths.dashboard.item.product, 
            icon: ICONS.products,
            children: [
              { title: 'Products', path: paths.dashboard.item.product },
              { title: 'Packages', path: paths.dashboard.item.package },
              { title: 'Combos', path: paths.dashboard.item.combo }
            ]
          },
          { 
            title: 'Price Management', 
            path: paths.dashboard.item.pricing, 
            icon: ICONS.price,
            children: [
              { title: 'Individual Pricing', path: paths.dashboard.item.pricing },
              { title: 'Bulk Pricing', path: paths.dashboard.item.bulk_pricing }
            ]
          },
          { 
            title: 'Obsolete Products', 
            path: paths.dashboard.item.expires, 
            icon: ICONS.damages,
            children: [
              { title: 'Expires', path: paths.dashboard.item.expires},
              { title: 'Damages', path: paths.dashboard.item.damages},
            ]
          },
          { 
            title: 'Product Groups', 
            path: paths.dashboard.item.category, 
            icon: ICONS.categories,
            children: [
              { title: 'Categories', path: paths.dashboard.item.category },
              { title: 'Product Groups', path: paths.dashboard.item.product_group }
            ]
          }
        ]
      },

      // ORDER
      // ----------------------------------------------------------------------
      {
        subheader: 'Order Management',
        items: [
          { title: 'Order Insights', path: paths.dashboard.order.insights, icon: ICONS.insight },
          { title: 'Orders', path: paths.dashboard.order.all, icon: ICONS.orders },
          { title: 'Reviews', path: paths.dashboard.order.review, icon: ICONS.reviews },
        ]
      },

      // DELIVERY
      // ----------------------------------------------------------------------
      {
        subheader: 'Delivery Management',
        items: [
          { title: 'Sales Insights', path: paths.dashboard.delivery.insights, icon: ICONS.insight },
          { title: 'Delivery Person', path: paths.dashboard.delivery.driver, icon: ICONS.delivery_person },
          { 
            title: 'Returns and Refunds', 
            path: paths.dashboard.delivery.returns, 
            icon: ICONS.returns,
            children: [
              { title: 'Order Returns', path: paths.dashboard.delivery.returns},
              { title: 'Refunds', path: paths.dashboard.delivery.returns_refund }
            ]
          },
          { 
            title: 'Regional Management', 
            path: paths.dashboard.delivery.zones, 
            icon: ICONS.location,
            children: [
              { title: 'Zones', path: paths.dashboard.delivery.zones },
              { title: 'Cities', path: paths.dashboard.delivery.cities }
            ]
          },
          { title: 'Delivery Utilities', path: paths.dashboard.delivery.utilities, icon: ICONS.delivery_utility },
        ]
      },

      // CONFIGURATION
      // ----------------------------------------------------------------------
      {
        subheader: 'System Configuration',
        items: [
          { title: 'Mobile app banner', path: paths.dashboard.configuration.banner, icon: ICONS.banner_config },
          { title: 'Featured product', path: paths.dashboard.configuration.featured, icon: ICONS.category_config }
        ]
      },

      // PROFILE
      // ----------------------------------------------------------------------
      {
        subheader: 'Profile',
        items: [
          { title: 'Security', path: paths.dashboard.profile.security, icon: ICONS.security },
        ],
      },
    ],
    []
  );

  return data;
}
